import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';

interface NavbarProps {
    onSfogliaMenu: () => void;
    onMenuFeste: () => void;
    onEventi: () => void;
    onDelivery: () => void;
    onSelectSection?: (section: string) => void;
    activeSection?: string;
}

const Navbar: React.FC<NavbarProps> = ({ onSfogliaMenu, onMenuFeste, onEventi, onDelivery, onSelectSection }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { features } = useTenant();
    const deliveryEnabled = Boolean(features?.deliveryEnabled);
    const browseMenuEnabled = Boolean(features?.browseMenuEnabled ?? true); // Default true per backward compatibility

    return (
        <nav className="navbar">
            {browseMenuEnabled && (
                <button onClick={onSfogliaMenu}>{t('navbar.browseMenu')}</button>
            )}
            <button onClick={onMenuFeste}>{t('navbar.partyMenu')}</button>
            <button onClick={onEventi}>{t('navbar.events')}</button>
            {deliveryEnabled && (
                <button
                    onClick={() => {
                        onDelivery();
                        onSelectSection?.('delivery');
                        navigate('/delivery');
                    }}
                >
                    {t('navbar.delivery')}
                </button>
            )}
        </nav>
    );
};

export default Navbar;